#!/usr/bin/env node
import path from 'path';

import { formatXcodeBuildPipeProcessAsync } from './Runner';

const projectRoot = path.resolve(process.argv[2] || '.');

formatXcodeBuildPipeProcessAsync(projectRoot);
